import React, { useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { logo, logo111, signature } from "../../../assets/img";

const GenerateOfferLetter = () => {
    const ref = useRef();

    const [d, setD] = useState({
        ref: "HRO Chennai/2022/R001162",
        date: "September 16, 2025",
        name: "",
        designation: "",
        manager: "",
        doj: "",
        empId: "",
        department: "",
        monthly: "",
        annual: ""
    });

    const handleChange = (e) => {
        setD({ ...d, [e.target.name]: e.target.value });
    };

    const downloadPDF = async () => {
        if (!ref.current) {
            console.error("Ref not found");
            return;
        }

        const pdf = new jsPDF("p", "mm", "a4");

        const pages = ref.current.querySelectorAll(".page_11");

        if (!pages.length) {
            console.error("No pages found");
            return;
        }

        for (let i = 0; i < pages.length; i++) {
            const canvas = await html2canvas(pages[i], { scale: 2 });
            const img = canvas.toDataURL("image/png");

            const w = 210;
            const h = (canvas.height * w) / canvas.width;

            if (i > 0) pdf.addPage();

            pdf.addImage(img, "PNG", 0, 0, w, h);
        }

        pdf.save(`${d.name || "OfferLetter"}.pdf`);
    };
    return (
        <div className="offer-container" >            {/* INPUTS */}
            <div className="offer-form">
                <input name="name" placeholder="Employee Name" onChange={handleChange} />
                <input name="designation" placeholder="Designation" onChange={handleChange} />
                <input name="manager" placeholder="Manager Name" onChange={handleChange} />
                <input name="doj" placeholder="Date of Joining" onChange={handleChange} />
                <input name="empId" placeholder="Employee ID" onChange={handleChange} />
                <input name="department" placeholder="Department" onChange={handleChange} />
                <input name="monthly" placeholder="Monthly Salary" onChange={handleChange} />
                <input name="annual" placeholder="Annual Salary" onChange={handleChange} />
            </div>
            {/* DOCUMENT */}

            <div className="" ref={ref}>
                <div className="page_11">
                    <img src={logo111} className="watermark-logo" />
                    <div className="header_11">
                        <img src={logo} className="logo1111" />
                    </div>

                    <div className="content_11">
                        <div className="p-3">
                            <p className="f2 fs-14"><b>Ref :</b> {d.ref}</p>
                            <p className="f2 fs-14">{d.date}</p>
                            <p className="f2 fs-14 py-2"><b>Sub: Appointment Letter</b></p>

                            <p className="f2 fs-14">Dear Ms. {d.name},</p>
                        </div>
                        <p className="f2 fs-14">
                            It is with great pleasure that I writing this letter on behalf of redcloud Soft Solutions Private Limited (redcloud India) to provide an offer to work as a
                            <b>{d.designation}</b>,and it gives me great joy to do so. This is a full-time role, and  <b>{d.manager}</b>will be your immediate supervisor. Redcloud is an expert in business intelligence and data warehouse solutions, including their design, development, implementation, and management. Redcloud is an Indian company that is expanding quickly.
                        </p>
                        <div className="p-2">
                            <div>
                                <h4 className="heading-double-line">
                                    Employment Terms and Conditions
                                </h4>
                            </div>

                            <ul className="offer-list">
                                <li>
                                    <p className="f2 fs-14"><b>Appointment/Date of Joining:</b> Your appointment is effective from {d.doj}
                                        and contingent upon satisfactory reference and background check which includes verification of your education and employment history.</p>
                                </li>

                                <li>
                                    <p className="f2 fs-14"> <b>Salary:</b> Your remuneration is strictly between you and the Company. It has been determined based on numerous factors like your job role, skills and professional merit. This information should be treated as personal and confidential. Your salary structure is shown in  <b>Annexure1</b>.</p>                    </li>

                                <li>
                                    <p className="f2 fs-14"> <b>Other Benefits:</b> During your employment redcloud will provide you with medical and personal accident insurances along with vacation, sick leave, casual leave and company specified holidays.</p>
                                </li>

                                <li>
                                    <p className="f2 fs-14"><b>Appraisal & Incentive:</b> Annual appraisals and incentives will be applicable as per the company policy.</p>
                                </li>

                                <li>
                                    <p className="f2 fs-14"> <b>Probation:</b> Upon successful Completion of 6 months of continuous employment subject to satisfactory performance during this period, your services will be confirmed. For clarity, Probation period varies from a minimum period of six months up to a maximum period of satisfaction and that satisfaction wholly vests with the COMPANY.</p>
                                </li>

                                <li>

                                    <p className="f2 fs-14"> <b>Designation:</b> Your designation may be changed depending on the work assigned to you at the discretion of the Company.</p>

                                </li>
                                <li>

                                    <p className="f2 fs-14"> <b>Employment Practices:</b> During your employment with the company, you will abide by the service rules, regulations and policies of the company as mentioned in the HR handbook published in Intranet and amended from time to time. All employees are required to read and comply with redcloud’s policy. Any breach of the policy or the terms and conditions of employment may result in termination of your services without notice or compensation.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer_11">
                        <div className="company-header">
                            <h4 className="f3 fs-14">redcloud Soft Solution Private Limited</h4>
                            <p className="f1 fs-14">173,6th Floor, Block B, TECCI Park, OMR, Shollinganallur, Chennai - 600119</p>
                            <p className="f1 fs-14">+91-90439 02239 | WWW.redcloudsolutions.in | hr@redcloudsolutions.in</p>
                            <p className="f1 fs-14">CIN U72900TN2022PTC154867</p>

                        </div>
                    </div>
                </div>
                {/* SECOND HALF TERMS */}
                <div className="page_11">
                    <img src={logo111} className="watermark-logo" />

                    <div className="header_11">
                        <img src={logo} className="logo1111" />
                    </div>

                    <div className="content_11 ">

                        <ul className="offer-list p-2">

                            <li>
                                <p className="f2 fs-14"><b>Workdays:</b> : We work 5 days a week Monday to Friday but depending on client requirements you may have different workdays and you are required to abide by the workdays requested by the Project Leads.</p>
                            </li>

                            <li>
                                <p className="f2 fs-14"><b>Shift Timings:</b> The regular work hours are from 9:00 AM to 6:00 PM. Depending on the project requirements you may be required to work in afternoon, night or any other shifts as per the instructions from the Project Lead or any other designated person.</p>
                            </li>

                            <li>
                                <p className="f2 fs-14"><b>Resignation/Termination of Service:</b> The employment with the Company may be terminated by either party giving to the other, 90 days prior written notice or salary in lieu of, provided, in the event that termination in either of the situation above, wherein the notice of resignation is given at the instance of employee, the Company shall have the sole discretion to decide the date of relieving during the notice period including the right expressively reserved hereby to waive the notice period in full or part, without paying any amount towards the balance notice period.</p>
                                <p className="f2 fs-14">The company reserves the right to terminate the employment agreement with or without notice in these cases-gross misconduct/disciplinary issues, poor performance, violence of ethical standards and/or community’s values and standards, fraud, etc. In such cases the service of the employee with the company will be terminated with immediate effect.</p>
                            </li>

                            <li>
                                <p className="f2 fs-14"><b>Confidentiality of Information: </b> redcloud’s information on operations and intellectual property is confidential and you are required to sign a Confidentiality and Invention/ideas Agreement.</p>
                            </li>
                            <li>
                                <p className="f2 fs-14"><b>Deputation:</b> Although your work location is Chennai, you may be deputed to work at any one of the other offices/Locations of the company/Client as and when considered necessary, solely at the discretion of the management.</p>
                            </li> <li>
                                <p className="f2 fs-14"><b>Travel:</b> You may be required to travel on company work and the expenses will be reimbursed as per the company’s policy.</p>
                            </li> <li>
                                <p className="f2 fs-14">
                                    <b>Absence from work:</b> If you are not at work for a continuous period of 5 working days without informing HR or obtaining your manager’s approval, we consider your absence as termination of service without notice.
                                </p>
                            </li> <li>
                                <p className="f2 fs-14">
                                    <b>Company Assets:</b> On your resignation from the Company or termination of your services, you need to return all assets and property of the Company such as documents, laptops, files, books etc. (including but not limited to leased property).
                                </p>
                            </li> <li>
                                <p className="f2 fs-14"><b>Personal information:</b> It is the employee’s responsibility to notify the Company of any changes in your personal information within 3 working days.</p>
                            </li>
                        </ul>
                    </div>
                    <div className="footer_11">
                        <div className="company-header">
                            <h4 className="f3 fs-14">redcloud Soft Solution Private Limited</h4>
                            <p className="f1 fs-14">173,6th Floor, Block B, TECCI Park, OMR, Shollinganallur, Chennai - 600119</p>
                            <p className="f1 fs-14">+91-90439 02239 | WWW.redcloudsolutions.in | hr@redcloudsolutions.in</p>
                            <p className="f1 fs-14">CIN U72900TN2022PTC154867</p>

                        </div>
                    </div>
                </div>
                {/* ACCEPTANCE SECTION */}
                <div className="page_11">
                    <img src={logo111} className="watermark-logo" />

                    <div className="header_11">
                        <img src={logo} className="logo1111" />
                    </div>

                    <div className="content_11">
                        <div className="p-4">
                            <ul className="offer-list p-2">
                                <li>
                                    <p className="f2 fs-14"><b>Terms & Conditions: </b>Any terms and conditions of your service may be modified or changed at the Company’s discretion.</p>
                                </li>

                            </ul>
                            <p className="f2 my-3 fs-14">This is an exciting phase for redcloud. We are pleased to have you joining our organization at this time and hope that you will find your employment at redcloud a rewarding experience. We look forward to an enjoyable and mutually rewarding relationship!</p>
                            <p className="f2 fs-14">Sincerely,</p>

                            <img src={signature} className="sign" alt="" />
                            <p className="f2 fs-16"><b>Vice President</b></p>

                            {/* ACCEPTANCE */}
                            <div className="mt-5">
                                <h4 className="heading-double-line">
                                    ACCEPTANCE
                                </h4>
                            </div>


                            <p className="f2 fs-12">
                                I, __________________________, , hereby confirm that I have read and understood the Terms and Conditions of Employment mentioned above and confirm my agreement to them and hereby accept the Company’s offer of appointment without any reservations whatsoever. I confirm that I have voluntarily offered my services to the Company and that neither the Company nor any of its officers or employees have solicited my services by persuading me to terminate any other contract of employment or otherwise.
                            </p>
                            <table className="signature-table">
                                <tbody>
                                    <tr>
                                        <td className="label f2 fs-12">Signature</td>
                                        <td className="colon f2 fs-12">:</td>
                                        <td className="line f2 fs-12">____________</td>
                                    </tr>
                                    <tr>
                                        <td className="label f2 fs-12">Date of Joining</td>
                                        <td className="colon f2 fs-12">:</td>
                                        <td className="line f2 fs-12">____________</td>
                                    </tr>
                                    <tr>
                                        <td className="label f2 fs-12">Date Time</td>
                                        <td className="colon f2 fs-12">:</td>
                                        <td className="line f2 fs-12">____________</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>

                    <div className="footer_11">
                        <div className="company-header">
                            <h4 className="f3 fs-14">redcloud Soft Solution Private Limited</h4>
                            <p className="f1 fs-14">173,6th Floor, Block B, TECCI Park, OMR, Shollinganallur, Chennai - 600119</p>
                            <p className="f1 fs-14">+91-90439 02239 | WWW.redcloudsolutions.in | hr@redcloudsolutions.in</p>
                            <p className="f1 fs-14">CIN U72900TN2022PTC154867</p>

                        </div>
                    </div>
                </div>
                {/* ANNEXURE TABLE */}
                <div className="page_11">
                    <img src={logo111} className="watermark-logo" />

                    <div className="header_11">
                        <img src={logo} className="logo1111" />
                    </div>

                    <div className="content_11">
                        <h4 className="annex-title">Annexure 1</h4>
                        <div className="annecure-contanier f2">
                            {/* EMPLOYEE DETAILS */}
                            <table className="annex-details">
                                <tbody>
                                    <tr>
                                        <td className="f2 fs-14">Name</td>
                                        <td className="f2 fs-14">:</td>
                                        <td className="f2 fs-14">{d.name}</td>
                                    </tr>
                                    <tr>
                                        <td className="f2 fs-14">Emp ID</td>
                                        <td className="f2 fs-14">:</td>
                                        <td className="f2 fs-14">{d.empId}</td>
                                    </tr>
                                    <tr>
                                        <td className="f2 fs-14">Designation</td>
                                        <td className="f2 fs-14">:</td>
                                        <td className="f2 fs-14">{d.designation}</td>
                                    </tr>
                                    <tr>
                                        <td className="f2 fs-14">Department</td>
                                        <td className="f2 fs-14">:</td>
                                        <td className="f2 fs-14">{d.department}</td>
                                    </tr>
                                    <tr>
                                        <td className="f2 fs-14">Effective Date</td>
                                        <td className="f2 fs-14">:</td>
                                        <td className="f2 fs-14">{d.doj}</td>
                                    </tr>
                                </tbody>
                            </table>
                            {/* SALARY TABLE */}
                            <table className="annex-salary">
                                <thead>
                                    <tr>
                                        <th className="f3 fs-16"></th>
                                        <th className="f3 fs-16">Per Month</th>
                                        <th className="f3 fs-16">Per Annum</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr className="bold-row">
                                        <td className="f2 fs-14">Gross Pay</td>
                                        <td className="f2 fs-14">{d.monthly}</td>
                                        <td className="f2 fs-14">{d.annual}</td>
                                    </tr>

                                    <tr>
                                        <td colSpan="3" className="section-title f3 fs-15">
                                            Components:
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">Basic</td>
                                        <td className="f2 fs-14">52,000.00</td>
                                        <td className="f2 fs-14">6,24,000.00</td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">HRA</td>
                                        <td className="f2 fs-14">26,000.00</td>
                                        <td className="f2 fs-14">3,12,000.00</td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">Special Allowance</td>
                                        <td className="f2 fs-14">43,190.00</td>
                                        <td className="f2 fs-14">5,18,280.00</td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">Conveyance Allowance</td>
                                        <td className="f2 fs-14">800.00</td>
                                        <td className="f2 fs-14">9,600.00</td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">Medical Allowance</td>
                                        <td className="f2 fs-14">1,250.00</td>
                                        <td className="f2 fs-14">15,000.00</td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">City Compensatory Allowance</td>
                                        <td className="f2 fs-14">6,760.00</td>
                                        <td className="f2 fs-14">81,120.00</td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">Variable Pay</td>
                                        <td className="f2 fs-14"></td>
                                        <td className="f2 fs-14">1,56,000.00</td>
                                    </tr>


                                    <tr className="row-border-only">
                                        <td className="f2 fs-15">Total Monthly Pay-Out</td>
                                        <td className="f2 fs-15">{d.monthly}</td>
                                        <td className="f2 fs-15">{d.annual}</td>
                                    </tr>

                                    <tr className="row-border-only">
                                        <td colSpan="3" className="section-title f3 fs-15">
                                            Level-2 / Deductions
                                        </td>
                                    </tr>

                                    <tr>
                                        <td className="f2 fs-14">Professional Tax</td>
                                        <td className="f2 fs-14">208.00</td>
                                        <td className="f2 fs-14">2,496.00</td>
                                    </tr>

                                    <tr className="pf_border">
                                        <td className="f2 fs-14">PF</td>
                                        <td className="f2 fs-14">1,800.00</td>
                                        <td className="f2 fs-14">21,600.00</td>
                                    </tr>


                                    <tr>
                                        <td className="f2 fs-14">&nbsp;</td>
                                        <td className="f2 fs-14">&nbsp;</td>
                                        <td className="f2 fs-14">&nbsp;</td>
                                    </tr>




                                    <tr className="row-border-only">
                                        <td className="f2 fs-15">Total</td>
                                        <td className="f2 fs-15">8,508.00</td>
                                        <td className="f2 fs-15">1,02,096.00</td>
                                    </tr>
                                    <tr className="row-border-only">
                                        <td className="f2 fs-15">&nbsp;</td>
                                        <td className="f2 fs-15">&nbsp;</td>
                                        <td className="f2 fs-15">&nbsp;</td>
                                    </tr>



                                    <tr className="row-border-only">
                                        <td className="f2 fs-16">Total Cost to Company (CTC)</td>
                                        <td className="f2 fs-16">1,21,492.00</td>
                                        <td className="f2 fs-16">14,57,904.00</td>
                                    </tr>
                                </tbody>
                            </table>

                            <p className="note f2 fs-13">
                                * Incentives & Bonuses will be calculated and processed as per the company policy.
                            </p>

                            <p className="company-sign f2 fs-14">
                                For redcloud Soft Solutions Pvt Ltd
                            </p>
                            <img src={signature} className="sign" alt="" />

                            <p className="sign-name f3 fs-16">Sureshkumar</p>
                            <p className="sign-role f2 fs-14">Vice President</p>
                        </div>
                    </div>

                    <div className="footer_11">
                        <div className="company-header">
                            <h4 className="f3 fs-14">redcloud Soft Solution Private Limited</h4>
                            <p className="f1 fs-14">173,6th Floor, Block B, TECCI Park, OMR, Shollinganallur, Chennai - 600119</p>
                            <p className="f1 fs-14">+91-90439 02239 | WWW.redcloudsolutions.in | hr@redcloudsolutions.in</p>
                            <p className="f1 fs-14">CIN U72900TN2022PTC154867</p>

                        </div>
                    </div>
                </div>
            </div>
            
            <button onClick={downloadPDF} className="btn">
                Download PDF
            </button>
        </div>
    );
};

export default GenerateOfferLetter;